import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { GungSettingsPunchoutCartTransfersTableComponent } from '../components/gung-settings/gung-settings-punchout/punchout-cart-transfers/gung-settings-punchout-cart-transfers-table.component';
import {
  PunchoutAuditConfigFilter,
  PunchoutAuditMonthFilter,
  PunchoutAuditOutcomeFilter
} from '../filters/punchout-audit/punchout-audit.filters';
import { PunchoutAuditEventType, PunchoutAuditListItem } from '../models/punchout';
import { PunchoutAuditListConfigBase } from './punchout-audit-list-config.base';

/**
 * Cart transfers: the PunchOutOrderMessage posted back to the procurement platform at checkout.
 * A request for this type also returns entries stored before the type field existed. The
 * backend folds those entries into PUNCHOUT_ORDER_MESSAGE.
 */
@Injectable({ providedIn: 'root' })
export class PunchoutAuditCartTransferListConfigService extends PunchoutAuditListConfigBase {
  protected readonly eventType: PunchoutAuditEventType = 'PUNCHOUT_ORDER_MESSAGE';

  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<PunchoutAuditListItem>[] {
    return [new PunchoutAuditConfigFilter(), new PunchoutAuditOutcomeFilter(), new PunchoutAuditMonthFilter()];
  }

  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<PunchoutAuditListItem>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => GungSettingsPunchoutCartTransfersTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'list'
      }
    ];
  }
}
